import jQuery from "utilities/vendor/jquery/3.5.1/js/jquery";
import $ from "utilities/vendor/jquery/3.5.1/js/jquery";
import Module from "utilities/global/sparta-module-utility/6.2.5/js/sparta-module-utility";
import shareContent from "utilities/global/share-content-utility/2.1.0/js/share-content-utility";
import spartaTemplates from "modules/global/search-stub-module/5.2.1/js/templates";
import "css!modules/global/search-stub-module/5.2.1/css/search-stub-module.scss.css";
import "css!modules/global/search-stub-module/5.2.1/css/search-base.scss.css";









export default class searchStubModuleJS extends Module {
  constructor(options) {
    options.target = '.search-stub-module';
    super(options);
  }

  init(options) {


    if (!window.jQuery) {
      window.jQuery = $;
    }


    this.defaults = {
      target: '.nav-search',
      $target: $(),
      toggle: '.nav-search-toggle',
      $toggle: $(),
      container: '.header-search',
      menu: '.header-panel-toggle.menu-icon',
      $menu: $(),
    };


    this.required = {
      data: {
        component: 'module',
        module: 'header',
        skin: 'nav-search',
      },
    };


    this.settings = $.extend({}, this.defaults, options, this.required);
    this.settings.$target = $(this.settings.target);
    this.settings.$toggle = $(this.settings.toggle);
    this.settings.$menu = $(this.settings.menu);



    for (const data in this.settings.data) {
      if (this.settings.$target.data(data)) {
        this.settings.data[data] = this.settings.$target.data(data);
      }
    }
    if (!this.checkConfig()) {
      return;
    }

    this.wireNLH();
  }

  checkConfig() {
    let isValid = true;

    if (!spaParams.siteParams.secureHost) {
      isValid = false;
      console.error('Global nav search requires site parameter secureHost to be defined!');
    }

    return isValid;
  }

  wireNLH() {
    let $nlh = $();
    let $input = $();
    let $button = $();
    let $form = $();
    const self = this;

    const unbindDotcom = function (callback) {
      $nlh.removeClass('dotcom-bound');
      $button.off('click.dotcom');
      $input.off('focus.dotcom');
      $('body').off('click.dotcom');
      if (typeof callback === 'function') {
        callback();
      }
    };

    const passClickToSubmit = function (e) {

      if ($('html').hasClass('spa-ua-mobile')) {
        return;
      }
      const $clicked = $(e.target);
      if ($clicked.hasClass('icon-search')) {
        e.preventDefault();
        e.stopPropagation();
        $clicked.parents('form').find('.submit').click();
      }
    };

    const submitNLH = function (e) {
      if (typeof e === 'object') {
        e.preventDefault();
      }

      const $thisForm = $(this);
      const term = $thisForm.find('input[type=text]').val();
      const url = $thisForm.attr('action');
      const query = (typeof term === 'string') ? escape(term) : '';
      const lang = (typeof $boaLangObj === 'object') ? $boaLangObj.boaLang.substr(0, 2) : 'en';
      const qs = `#?state={"query"%3A"${query}"%2C"lang"%3A"${lang}"}&id=1`;

      location.href = `${url}${qs}`;
      return false;
    };

    const loadNLHEmpty = function (e) {
      e.preventDefault();
      e.stopPropagation();

      const triggerSuggestions = function () {
        $('form', $nlh).submit();
      };
      const checkReady = function () {
        let checkCount = 0;
        const checkSearch = function () {
          checkCount += 1;
          if (
            (
              typeof boa === 'object'
              && typeof boa.search === 'object'
              && boa.search.isNavSearchInitialized
            )
            || checkCount > 50
          ) {
            clearInterval(checkInterval);
            triggerSuggestions();
          }
        };
        const checkInterval = setInterval(checkSearch, 250);
      };

      unbindDotcom.call(this, checkReady);
      loadNLH.call(this);
    };

    const loadNLH = function (e) {
      if (typeof e === 'object') {
        e.preventDefault();
      }


      const $thisForm = $input.parents('form');
      const assetEnv = spaParams.siteParams.secureHost;
      let cssPath = $thisForm.data('css');
      let jsPath = $thisForm.data('js');
      const completedAction = function () {
        self.settings.$toggle.click();
        $input.focus();
      };
      const completed = function () {
        $thisForm.off('submit.dotcom');
        if ($nlh.hasClass('dotcom-bound')) {
          unbindDotcom(function () {
            setTimeout(completedAction, 600);
          });
        } else {
          completedAction();
        }
      };
      const failed = unbindDotcom;
      const link = document.createElement('link');

      jsPath = `${assetEnv}${jsPath}`;
      cssPath = `${assetEnv}${cssPath}`;

      link.type = 'text/css';
      link.rel = 'stylesheet';
      link.href = cssPath;
      document.getElementsByTagName('head')[0].appendChild(link);


      $.ajax({
        url: jsPath,
        cache: true,
        dataType: 'script',
        success: completed,
        error: failed,
      });
    };

    const hideNavigation = function () {
      $('.spa-page-navigation').removeClass('expanded');
      this.settings.$menu.addClass('closed');
    };

    const hideSearch = function () {
      this.settings.$toggle.filter('.search-visible').click();
    };

    const setupEvents = function () {
      $('body').on('click.dotcom', passClickToSubmit.bind(this));
      $form.on('submit.dotcom', submitNLH.bind(this));
      $button.on('click.dotcom', loadNLHEmpty.bind(this));
      $input.attr('value', '').on('focus.dotcom', loadNLH.bind(this));
      self.settings.$toggle
        .one('click', loadNLH.bind(this))
        .click(hideNavigation.bind(this));
      self.settings.$menu.click(hideSearch.bind(this));
      $nlh.addClass('ready dotcom-bound');
    };

    const setupSearchPieces = function () {
      this.settings.$target = $(this.settings.target);
      $nlh = this.settings.$target;
      $input = $('input[type="text"]', $nlh);
      $button = $('input[type="submit"]', $nlh);
      $form = $input.parents('form');

      setupEvents();
    };

    const result = shareContent.init({
      criterion: 'breakpoint',
      content: 'search',
      action: 'move',
      callback: () => setupSearchPieces.call(this),
    });
  }


  injectIcons($container) {
    const $icons = $('[data-icon]', $container).add($container.filter('[data-icon]'));

    $icons.each(function () {
      const $object = $(this);
      const iconName = $object.data('icon');
      if (iconName === '#!') {
        return;
      }

      const iconParts = 4;
      const iconClass = $.map(iconName.split(' '), function (a) {
        return `icon-${a}`;
      }).join(' ');
      const $icon = $('<div class="icon">').addClass(iconClass);
      for (let i = 1; i <= iconParts; i += 1) {
        $icon.append(`<div class="icon-layer icon-layer--level${i}">`);
      }

      $object.removeData('icon').attr('data-icon', '#!');
      $object.append($icon);
    });
  }

  adjustForParams() {
    $('.default-nav-links').addClass('account-for-params');

    if ($('.nav-label').length) {
      $('.spa-nav-section-title').removeClass('account-for-params');
    } else {
      $('.spa-nav-section-title').addClass('account-for-params');
    }

    if ($('.default-nav-links').length) {
      $('.custom-nav-links').removeClass('account-for-params');
    } else {
      $('.custom-nav-links').addClass('account-for-params');
    }
  }
}
